import * as React from 'react';
import { Checkbox, Form, Input, message, Select } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { UserRoles } from '../../../Repository/UserRepository';
import CRUDModal from '../../../Component/Modal/CRUDModal';
import { Role } from 'tree-wallet-client';

const { Option } = Select;

interface ModalUserFormGenericProps{
  onClose?: Function;
  onSave?: Function;
  onOpen?: Function;
  openButton: React.ReactNode;
  editedObject?: any;
  modalTitle: string;
}

interface ModalUserFormGenericState{
  error: any;
  submitting: boolean;
}

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const sectors = [
  { label: 'industry', value: 'industry' },
  { label: 'automobile', value: 'automobile' },
  { label: 'mining', value: 'mining' },
  { label: 'pharmaceutical', value: 'pharmaceutical' },
  { label: 'other', value: 'other' },
];

export default class ModalUserFormGeneric extends React.Component<ModalUserFormGenericProps, ModalUserFormGenericState>{
  private readonly formRef: React.RefObject<FormInstance>;
  private readonly popupRef: React.RefObject<CRUDModal>;

  constructor(props: ModalUserFormGenericProps) {
    super(props);
    this.formRef = React.createRef();
    this.popupRef = React.createRef();
    this.onFinish = this.onFinish.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onFinishFailed = this.onFinishFailed.bind(this);
    this.state = {
      error: undefined,
      submitting: false,
    }
  }

  onCancel() {
    const { current: form } = this.formRef;
    form && form.resetFields();
  }

  onFinishFailed(error: any) {
    this.setState({ error })
  }

  async onFinish() {
    const { onSave, editedObject } = this.props;
    const { current: form } = this.formRef;

    if (form) {
      try {
        const values = await form.validateFields();
        const formData = new FormData();
        Object.entries(values).map(([key, value]) => formData.append(key, String(value)));
        formData.append('company', values['company'] ? 'true' : 'false');
        onSave && await onSave(editedObject, values);
        form.resetFields();
      } catch (err) {
        message.error(err);
      }
    }
    return true;
  }

  render() {
    const { openButton, editedObject, modalTitle } = this.props;
    const initialValues = !editedObject ? {} : {
      firstName: editedObject.first_name,
      lastName: editedObject.last_name,
      email: editedObject.email,
      role: JSON.parse(editedObject.roles)[0],
      company: editedObject.type === 'COMPANY',
      website: editedObject.website,
      sector: editedObject.sector,
      companyName: editedObject.company
    };

    const isCompany = this.formRef.current?.getFieldValue('company') || initialValues.company;

    const displayRoles = () => {
      const roles = Object.values(UserRoles.all);
      return roles.map((role: Role) => {
        return <Option value={role.name} key={role.name}>{role.label}</Option>
      })
    }

    return <CRUDModal
      ref={this.popupRef}
      editedObject={editedObject}
      openButton={openButton}
      modalTitle={modalTitle}
      onSave={this.onFinish}
      onCancel={this.onCancel}
      closeAfterSave={true}
    >
      <Form
        {...layout}
        name="basic"
        ref={this.formRef}
        onFinish={this.onFinish}
        onFinishFailed={this.onFinishFailed}
        onChange={() => this.setState({ error: undefined })}
        initialValues={initialValues}
      >
        <Form.Item
          label="Role"
          name="role"
          required
          rules={[{ required: true, message: 'Please set a role' }]}
        >
          <Select
            style={{ width: 200 }}
            placeholder="Select a role"
          >
            {displayRoles()}
          </Select>
        </Form.Item>

        <Form.Item
          label="First name"
          name="firstName"
          required
          rules={[{ required: true, message: 'Please enter a first name' }]}
        >
          <Input placeholder="First name" />
        </Form.Item>

        <Form.Item
          label="Last name"
          name="lastName"
          required
          rules={[{ required: true, message: 'Please enter a last name' }]}
        >
          <Input placeholder="Last name" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          required
          rules={[{ required: true, message: 'Please enter an email', type: 'email' }]}
        >
          <Input placeholder="Email address" />
        </Form.Item>
        <Form.Item
          name="company"
          valuePropName="checked"
          required
        >
          <Checkbox defaultChecked={false}>
            User is representing a company
          </Checkbox>
        </Form.Item>
        {isCompany &&
          <>
            <Form.Item
              label="Company Name"
              name="companyName"
              required
              rules={[{ required: true, message: 'Please enter a name', type: 'string' }]}
            >
              <Input placeholder="Enter your company's name" type={'text'} />
            </Form.Item>
            <Form.Item
              label="Sector"
              name="sector"
              required
              rules={[{ required: true, message: 'Please select a sector' }]}
            >
              <Select
                style={{ width: 200 }}
                placeholder="Select a sector"
              >
                {Object.values(sectors).map((sector: any) => {
                  return <Option key={''} value={sector.value}>{sector.label}</Option>
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label="Website"
              name="website"
              required
              rules={[{ required: true, message: 'Please enter a website', type: 'url' }]}
            >
              <Input placeholder="Enter your company's website URL" type={'url'}/>
            </Form.Item>
          </>
        }
      </Form>
    </CRUDModal>
  }
}
